import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Dropdown, Button, Icon, Grid, Modal} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import InternalOrderTable from './table';
import './internalOrderEdit.scss';

class InternalOrderForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'clientTmp': '',
      'clientSelected': '',
      'warehouseTmp': '',
      'warehouseSelected': '',
    };
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
  }

  componentDidMount() {
    if (!(hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Edit) ||
    hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Create) ||
    hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.ForOthers))) {
      this.props.push(paths.AccessDenied);
    }

    const {isOrderNew} = this.props;
    this.props.clearInternalOrderForm();
    this.props.fetchDealers('clients');
    this.props.fetchWarehouses();
    if (!isOrderNew) {
      this.props.fetchInternalOrder(this.props.orderCodeByUrl);
    }
  }

  componentDidUpdate() {
    const {isOrderNew} = this.props;

    if (!isOrderNew) {
      this.loadHeaderData();
    }
  }

  loadHeaderData() {
    const {clientRuc, warehouse} = this.props;
    const {clientSelected, warehouseSelected} = this.state;

    const newState = {};
    if (clientRuc && clientSelected !== clientRuc) {
      newState.clientSelected = clientRuc;
      newState.clientTmp = clientRuc;
    }
    if (warehouse && warehouseSelected !== warehouse) {
      newState.warehouseSelected = warehouse;
      newState.warehouseTmp = warehouse;
    }
    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  async onDeleteOrderClick(orderCode) {
    const returnToList = true;
    await this.props.deleteInternalOrder(orderCode, returnToList);
    this.props.push(paths.InternalOrdersList);
  }

  getClients() {
    return this.props.clients.map((element, index) => {
      return {'key': index, 'text': element.name, 'value': element.identification};
    });
  }

  changeClient(value) {
    this.setState({'clientTmp': value}, () => this.updateDataForClient());
  }

  updateDataForClient() {
    const {clientSelected, clientTmp} = this.state;
    if (clientSelected === clientTmp) {
      return;
    }
    this.setState({'clientSelected': clientTmp});
  }

  getWarehouses() {
    const warehousesAllowed = [];
    this.props.warehouses.forEach((element) => {
      if (hasAccessPermission(this.props.permissions, `Bodega ${element.code}`, 'Crear Pedido Interno')) {
        warehousesAllowed.push(element);
      }
    });

    return warehousesAllowed.map((element) => {
      return {'text': element.description, 'value': element.code};
    });
  }

  changeWarehouse(value) {
    this.setState({'warehouseTmp': value}, () => this.updateDataForWarehouse());
  }

  updateDataForWarehouse() {
    const {warehouseSelected, warehouseTmp} = this.state;
    if (warehouseSelected === warehouseTmp) {
      return;
    }
    this.setState({'warehouseSelected': warehouseTmp});
  }

  onSaveClick() {
    const data = {'clientRuc': this.state.clientSelected, 'warehouse': this.state.warehouseSelected};
    this.props.createInternalOrder(data);
  }

  renderRejectButton() {
    const {orderCode, loadingClients, loadingWarehouses, savingLineInfo, deleting} = this.props;
    if (!orderCode || !hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Delete)) {
      return null;
    }

    return (
      <Modal size='mini'
        trigger={
          <span>
            <Button
              type='button'
              secondary
              className='toyota-primary'
              disabled={loadingClients || loadingWarehouses || savingLineInfo || deleting}
              loading={loadingClients || loadingWarehouses}
            >
              Rechazar
            </Button>
          </span>
        }
        header='¿Está seguro que desea eliminar el pedido?'
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar', 'positive': true,
            'onClick': () => this.onDeleteOrderClick(orderCode),
            'primary': true,
          },
        ]}
      />
    );
  }

  renderSaveButtonOrOrderCode() {
    const {clientSelected, warehouseSelected} = this.state;
    const {orderCode, loadingClients, loadingWarehouses} = this.props;
    if (orderCode) {
      return (
        <Grid.Column width={3} textAlign='left'>
          <h4># Pedido: <span>{orderCode}</span></h4>
        </Grid.Column>
      );
    }
    return (
      <Grid.Column width={3} textAlign='right'>
        <Button
          type='button'
          primary
          className='toyota-primary'
          disabled={loadingClients || loadingWarehouses || !clientSelected || !warehouseSelected}
          loading={loadingClients}
          onClick={this.onSaveClick}
        >
          Guardar
        </Button>
      </Grid.Column>
    );
  }

  render() {
    const {isOrderNew, loadingClients, loadingWarehouses} = this.props;
    const {clientTmp, warehouseTmp} = this.state;
    const title = isOrderNew ? 'Nuevo' : 'Editar';

    return (
      <div className='internal-order-edit-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick}/>
              <h2>{title} Pedido</h2>
              <div className='title-bar-actions'>
                {this.renderRejectButton()}
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Cliente</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Dropdown selection
                      options={this.getClients()}
                      search
                      value={clientTmp}
                      disabled={loadingClients || !isOrderNew}
                      loading={loadingClients}
                      onChange={(e, {value}) => this.changeClient(value)}
                      placeholder='Clientes'
                      noResultsMessage='Cliente no encontrado'
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Bodega</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Dropdown selection
                      options={this.getWarehouses()}
                      search
                      value={warehouseTmp}
                      disabled={loadingWarehouses || !isOrderNew}
                      loading={loadingWarehouses}
                      onChange={(e, {value}) => this.changeWarehouse(value)}
                      placeholder='Bodegas'
                      noResultsMessage='Bodega no encontrada'
                    />
                  </Grid.Column>
                  {this.renderSaveButtonOrOrderCode()}
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <InternalOrderTable />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {orderCode} = ownProps.params;
  const isOrderNew = orderCode ? false : true;
  const internalOrderToEdit = state.internalOrder.internalOrderToEdit;

  return {
    isOrderNew,
    'orderCodeByUrl': orderCode,
    'orderCode': internalOrderToEdit ? internalOrderToEdit.code : '',
    'clientRuc': internalOrderToEdit ? internalOrderToEdit.clientRuc : '',
    'warehouse': internalOrderToEdit ? internalOrderToEdit.warehouse : '',
    'loadingClients': state.dealer.loading,
    'clients': state.dealer.list,
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'savingLineInfo': state.internalOrder.creating,
    'deleting': state.internalOrder.deleting,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'goBack': ownProps.history.goBack,
  };
};

const {
  withRouter,
  clearInternalOrderForm,
  fetchInternalOrder,
  fetchDealers,
  fetchWarehouses,
  createInternalOrder,
  deleteInternalOrder,
  verifyStockInWarehouse,
  updateSubtotal,
  addItemToInternalOrder,
  deleteItemFromInternalOrder,
  addMessageBoxError,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearInternalOrderForm,
  fetchInternalOrder,
  fetchDealers,
  fetchWarehouses,
  createInternalOrder,
  deleteInternalOrder,
  verifyStockInWarehouse,
  updateSubtotal,
  addItemToInternalOrder,
  deleteItemFromInternalOrder,
  addMessageBoxError,
})(InternalOrderForm));
